import {createApp} from 'vue';
import {LoadingPlugin} from 'vue-loading-overlay';
import VueAwesomePaginate from "vue-awesome-paginate";
import axios from 'axios';
import Toast, { POSITION }  from "vue-toastification";
import {createBootstrap, vBColorMode, useColorMode} from 'bootstrap-vue-next';
import mitt from 'mitt';


// Add the necessary CSS
import "vue-toastification/dist/index.css";
import 'vue-loading-overlay/dist/css/index.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import "vue-awesome-paginate/dist/style.css";

import router from './router';
import store from './store';
import i18n from './i18n';
import App from './views/App.vue';




const instance = axios.create({
    withCredentials: true
});
window.axios = instance;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.interceptors.response.use(function(response){
    return response;
}, function(error){
    if(error.response.status === 401){
       /* Vue.notify({
            type: 'error',
            title: 'Authorization',
            text: 'You have been logged out, session expired?'
        }); */

        //this.$store.commit('setState', false);
        localStorage.removeItem('status');

        if(router.currentRoute.name !== 'login'){
            router.push({name: 'login'});
        }
        //return error.response;
        return Promise.reject(error)


    }else{
        //return error.response;
        return Promise.reject(error)
    }
});

const emitter = mitt();

const app = createApp(App);

app.config.globalProperties.emitter = emitter;

app.use(createBootstrap({components: true, directives: true}));
app.use(LoadingPlugin);
app.use(router);
app.use(store);
app.use(i18n);
app.use(VueAwesomePaginate);
app.use(Toast, {
    // Setting the global default position
    position: POSITION.TOP_CENTER
});
app.mount('#app');
